import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Container, Grid } from "@mui/material";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function DefaultFooter({ content }) {
  const { brand, socials, menus, copyright } = content;

  return (
    <MKBox component="footer">
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={8} md={2} sx={{ mb: 3 }}>
            <MKBox>
              <MKTypography variant="h6">{brand.name}</MKTypography>
            </MKBox>
            <MKBox display="flex" alignItems="left" mt={3} flexDirection="column">
              {socials.map(({ icon, link }, key) => (
                <MKTypography
                  key={key} // 각 아이콘을 고유하게 지정
                  component="a"
                  target={link ? "_blank" : "_self"} // 링크가 있으면 새 창으로 열기
                  rel="noreferrer"
                  variant="h5"
                  color="dark"
                  opacity={0.8}
                  mb={1} // 아이콘 간 간격 추가
                  sx={{
                    // 링크가 없을 때만 hover 효과 추가
                    "&:hover": link ? { opacity: 1 } : { opacity: 0.8 },
                  }}
                >
                  {icon}
                </MKTypography>
              ))}
            </MKBox>
          </Grid>

          {menus
            .filter(({ status }) => status !== false) // status가 false인 메뉴 제외
            .map(({ name: title, items }) => (
              <Grid key={title} item xs={10} md={3.2} sx={{ mb: 3 }}>
                <MKTypography
                  display="block"
                  variant="button"
                  fontWeight="bold"
                  textTransform="capitalize"
                  mb={1}
                >
                  {title}
                </MKTypography>
                <MKBox component="ul" p={0} m={0} sx={{ listStyle: "none" }}>
                  {items.map(({ name, route, href }) => (
                    <MKBox key={name} component="li" p={0} m={0} lineHeight={1.5}>
                      {href ? (
                        <MKTypography
                          component="a"
                          href={href}
                          target="_blank"
                          rel="noreferrer"
                          variant="button"
                          fontWeight="regular"
                          sx={{
                            // 링크가 없을 때만 hover 효과 추가
                            "&:hover": { opacity: 1 },
                          }}
                        >
                          {name}
                        </MKTypography>
                      ) : (
                        <MKTypography
                          component={Link}
                          to={route}
                          variant="button"
                          fontWeight="regular"
                          sx={{
                            // 링크가 없을 때만 hover 효과 추가
                            "&:hover": { opacity: 1 },
                          }}
                        >
                          {name}
                        </MKTypography>
                      )}
                    </MKBox>
                  ))}
                </MKBox>
              </Grid>
            ))}
          <Grid item xs={12} sx={{ textAlign: "center", my: 3 }}>
            {copyright}
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

DefaultFooter.propTypes = {
  content: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object, PropTypes.array])).isRequired,
};

export default DefaultFooter;
